import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-danger mb-4"
}
const _hoisted_4 = {
  key: 2,
  class: "s20 widget pt-8 pb-8"
}
const _hoisted_5 = { class: "flex px-6" }
const _hoisted_6 = { class: "s3_mobile px-4" }
const _hoisted_7 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "s4_mobile" }
const _hoisted_10 = { class: "my-2" }
const _hoisted_11 = { class: "font-normal my-2" }
const _hoisted_12 = { class: "text-primary-color my-4" }
const _hoisted_13 = { class: "flex gap-2 text-grey-600 my-3" }
const _hoisted_14 = { class: "tag-state notif stroke" }
const _hoisted_15 = { class: "s3_mobile px-2" }
const _hoisted_16 = { class: "flex flex-col gap-4" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import membersService from '@/services/membersService'
import { showAlert, showConfirm } from '@/utils/swal'

interface Member {
  id: number
  nom: string
  prenom: string
  collectivite?: {
    id: number
    nom: string
  }
  photo?: string
  photo_url?: string
  email?: string
  telephone?: string
  created_at?: string
  last_connection_at?: string
  actif?: number
  deleted_at?: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectiviteMembreDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const member = ref<Member | null>(null)
const loading = ref(false)
const actionLoading = ref(false)
const errorMessage = ref('')

onMounted(async () => {
  const memberId = route.params.id
  if (memberId) {
    await loadMember(Number(memberId))
  } else {
    router.push({ name: 'collectivites-membres' })
  }
})

async function loadMember(id: number) {
  try {
    loading.value = true
    errorMessage.value = ''
    const data = await membersService.getMember(id)
    member.value = data
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors du chargement du membre'
    // Rediriger vers la liste si le membre n'est pas trouvé
    setTimeout(() => {
      router.push({ name: 'collectivites-membres' })
    }, 2000)
  } finally {
    loading.value = false
  }
}

function formatDate(dateString?: string): string {
  if (!dateString) return '13/12/2025'
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

function goBack() {
  router.push({ name: 'collectivites-membres' })
}

async function doDeleteItem() {
  if (!member.value) return

  const confirmation = await showConfirm(
    `Voulez-vous vraiment supprimer le membre ${member.value.nom} ${member.value.prenom} ?`,
    'Confirmation de suppression'
  )
  if (!confirmation) return

  try {
    actionLoading.value = true
    errorMessage.value = ''
    await membersService.deleteMember(member.value.id)
    await showAlert.success('Membre supprimé avec succès.', 'Suppression réussie')
    // Rediriger vers la liste après suppression
    router.push({ name: 'collectivites-membres' })
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la suppression du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de suppression')
  } finally {
    actionLoading.value = false
  }
}

async function doRestoreItem() {
  if (!member.value) return

  const confirmation = await showConfirm(
    `Voulez-vous vraiment restaurer le membre ${member.value.nom} ${member.value.prenom} ?`,
    'Confirmation de restauration'
  )
  if (!confirmation) return

  try {
    actionLoading.value = true
    errorMessage.value = ''
    await membersService.restoreMember(member.value.id)
    await showAlert.success('Membre restauré avec succès.', 'Restauration réussie')
    // Recharger les données du membre
    await loadMember(member.value.id)
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la restauration du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de restauration')
  } finally {
    actionLoading.value = false
  }
}

async function doToggleEtatValideAction() {
  if (!member.value) return

  const confirmation = await showConfirm(
    `Voulez-vous vraiment modifier l'état du membre ${member.value.nom} ${member.value.prenom} ?`,
    'Confirmation de modification'
  )
  if (!confirmation) return

  try {
    actionLoading.value = true
    errorMessage.value = ''
    await membersService.toggleEtatValide([member.value.id])
    await showAlert.success('État du membre mis à jour avec succès.', 'Mise à jour réussie')
    // Recharger les données du membre
    await loadMember(member.value.id)
  } catch (error: any) {
    errorMessage.value = error.message || 'Erreur lors de la modification de l\'état du membre.'
    await showAlert.error(errorMessage.value, 'Erreur de mise à jour')
  } finally {
    actionLoading.value = false
  }
}

function handleEdit() {
  if (member.value) {
    router.push({ name: 'collectivites-membre-edit', params: { id: member.value.id } })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", { class: "d-flex align-items-center gap-4 mb-6" }, [
      _createElementVNode("button", {
        class: "btn white2",
        onClick: goBack
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: "/public/icons/icon-back.svg",
          class: "btn-icon",
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "Retour", -1)
      ]))]),
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-0" }, "Membres - Détail du membre", -1))
    ]),
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (member.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: member.value.photo_url ? member.value.photo_url : '/public/assets/users/300w/user2.jpg',
                  width: "100%"
                }, null, 8, _hoisted_8)
              ])
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "s1_mobile flex-center" }, " ", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(member.value.prenom || ''), 1),
              _createElementVNode("h6", _hoisted_11, _toDisplayString(member.value.prenom) + " " + _toDisplayString(member.value.nom), 1),
              _createElementVNode("h6", _hoisted_12, _toDisplayString(member.value.collectivite?.nom || 'N/A'), 1),
              _createElementVNode("p", _hoisted_13, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  src: "/public/icons/icon-time-glossy.svg",
                  class: "size-xs",
                  alt: ""
                }, null, -1)),
                _createTextVNode(" Dernière connexion: " + _toDisplayString(formatDate(member.value.last_connection_at || member.value.created_at)), 1)
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(member.value.actif === 1 ? 'Actif' : 'Inactif'), 1)
            ]),
            _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"s1_mobile flex-center\"><hr class=\"hr-vertical h-90p\"></div><div class=\"s9_mobile px-8\"><h5 class=\"text-grey-600 my-2\">1280 Actions</h5><h5 class=\"font-normal text-grey-600 my-2\">1280 Actions</h5><h5 class=\"font-normal text-grey-600 my-2\">1280 Actions</h5></div>", 2)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "btn",
                  onClick: handleEdit,
                  disabled: actionLoading.value
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-edit.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Editer", -1)
                ]))], 8, _hoisted_17),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-ultra color2", { 'display-none': member.value.deleted_at !== null || member.value.actif !== 1 }]),
                  disabled: actionLoading.value,
                  onClick: doToggleEtatValideAction
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-actif.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Actif")
                  ], -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-loading", { 'display-none': !actionLoading.value }])
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("div", { class: "loader-dots" }, null, -1)
                  ]))], 2)
                ], 10, _hoisted_18),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-ultra white2 tips", { 'display-none': member.value.deleted_at === null }]),
                  disabled: actionLoading.value,
                  onClick: doDeleteItem
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-destroy.svg",
                      class: "btn-icon icon-neutral",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Détruire")
                  ], -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-loading", { 'display-none': !actionLoading.value }])
                  }, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "loader-dots" }, null, -1)
                  ]))], 2)
                ], 10, _hoisted_19),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-ultra white2", { 'display-none': member.value.deleted_at !== null }]),
                  disabled: actionLoading.value,
                  onClick: doDeleteItem
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-delete.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Supprimer")
                  ], -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-loading", { 'display-none': !actionLoading.value }])
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "loader-dots" }, null, -1)
                  ]))], 2)
                ], 10, _hoisted_20),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn-ultra white2", { 'display-none': member.value.deleted_at === null }]),
                  disabled: actionLoading.value,
                  onClick: doRestoreItem
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "btn-show" }, [
                    _createElementVNode("img", {
                      src: "/public/icons/icon-restaurer.svg",
                      class: "btn-icon icon-neutral",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Restaurer")
                  ], -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["btn-loading", { 'display-none': !actionLoading.value }])
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("div", { class: "loader-dots" }, null, -1)
                  ]))], 2)
                ], 10, _hoisted_21)
              ])
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})